exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-7ea24d0e]{max-width:768px!important;margin:0 auto 50px}.image-cart[data-v-7ea24d0e]{width:100%;height:200px;object-fit:contain;object-position:center}.buttons[data-v-7ea24d0e]{margin:25px 0}.little_desc[data-v-7ea24d0e]{margin-top:5px;font-size:12px;color:#aaa;margin-left:5px}.btn-yellow[data-v-7ea24d0e]{background-color:#e8d800;color:#000;box-shadow:none!important;border:0}.btn-yellow[data-v-7ea24d0e]:hover{background-color:#000;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ea24d0e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/app/pages/auth/register.vue
// module id = 125
// module chunks = 0